import React, { useEffect, useState } from 'react';
import '.././App.css';
import Swal from 'sweetalert2';
import { db } from '../firebase';
import {
    collection,
    query,
    orderBy,
    onSnapshot,
    getDoc,
    getDocs,
    doc,
    where
} from 'firebase/firestore';
import { useParams } from 'react-router-dom';

export default function Productledger() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });

    const [products, setproducts] = useState([]);
    const [departmentName, setDepartmentName] = useState('');

    // pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); // Show 10 per page
    const { documentId } = useParams();

    useEffect(() => {
        fetchData();
    }, [documentId]);

    const fetchData = async () => {
        try {
            const productsQuery = query(
                collection(db, 'products'),
                orderBy('product', 'asc'),
                where('departmentid', '==', documentId)
            );
            onSnapshot(productsQuery, async (productsSnapshot) => {
                const products = productsSnapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                    departmentid: doc.data().departmentid
                }));

                // Fetch department name
                if (documentId) {
                    const deptRef = doc(db, 'departments', documentId);
                    const deptSnap = await getDoc(deptRef);
                    if (deptSnap.exists()) {
                        setDepartmentName(deptSnap.data().department || '');
                    }
                }

                // Fetch avakitems and javakitems
                const [avakSnapshot, javakSnapshot] = await Promise.all([
                    getDocs(collection(db, 'avakitems')),
                    getDocs(collection(db, 'javakitems'))
                ]);

                const avakQtyMap = {};
                const javakQtyMap = {};

                avakSnapshot.forEach((doc) => {
                    const { productid, quantity } = doc.data();
                    if (productid) {
                        avakQtyMap[productid] =
                            (avakQtyMap[productid] || 0) + (parseInt(quantity) || 0);
                    }
                });

                javakSnapshot.forEach((doc) => {
                    const { productid, quantity } = doc.data();
                    if (productid) {
                        javakQtyMap[productid] =
                            (javakQtyMap[productid] || 0) + (parseInt(quantity) || 0);
                    }
                });

                const combinedData = products.map((detail) => ({
                    id: detail.id,
                    data: detail.data,
                    avakqtytotal: avakQtyMap[detail.id] || 0,
                    javakqtytotal: javakQtyMap[detail.id] || 0
                }));

                setproducts(combinedData);
                setCurrentPage(1);
            });
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: error.message
            });
            console.error('FetchData Error:', error);
        }
    };

    // Pagination calculations
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = products.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(products.length / itemsPerPage);

    // ✅ Print function
    const handlePrint = () => {
        window.print();
    };

    return (
        <div>
            <div className="content-wrapper">
                <br />
                <section className="content">
                    <div className="container-fluid">
                        {/* Department Name */}
                        <h4 className="text-center">
                            <b>Department: {departmentName}</b>
                        </h4>

                        <div className="card card-primary card-outline ex1">
                            <div className="card-body table-responsive p-0">
                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Product Name</th>
                                            <th>Avak Qty</th>
                                            <th>Javak Qty</th>
                                            <th>Available Stock</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.map((item, index) => {
                                            const availableStock =
                                                (item.avakqtytotal || 0) - (item.javakqtytotal || 0);

                                            return (
                                                <tr key={item.id}>
                                                    <td width="80">
                                                        {indexOfFirstItem + index + 1}
                                                    </td>
                                                    <td>{item.data.product}</td>
                                                    <td>{item.avakqtytotal}</td>
                                                    <td>{item.javakqtytotal}</td>
                                                    <td>{availableStock}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>


                            </div>
                        </div>

                        <button
                            className="btn btn-primary"
                            style={{  marginBottom: '10px' }}
                            onClick={handlePrint}
                        >
                            <i className="fa fa-print"></i> Print
                        </button>
                    </div>
                </section>
            </div>
        </div>
    );
}
